import { render, staticRenderFns } from "./AdminRouterWrapper.vue?vue&type=template&id=059c68c9"
import script from "./AdminRouterWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminRouterWrapper.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports